/** The catalogue size as marketing states it ("over 5,000 cards", about page). One home for
 *  every surface that advertises it — paywalls, landing/company pages, SEO titles — so the
 *  next count change is one edit, not a sweep across three packages. */
export const CARD_COUNT_LABEL = "5,000+";
